import React from "react";

import { Helmet, HelmetProvider } from "react-helmet-async";

interface GuestLayoutProps {
	title?: string;
	sidebar?: any;
	navigation?: any;
	list?: any;
	children?: any;
}

const GuestLayout: React.FC<GuestLayoutProps> = ({ title = "Title unset!", children }): JSX.Element => {
	return (
		<div>
			<HelmetProvider>
				<Helmet>
					<title>{title}</title>
					<link rel="icon" href={process.env.REACT_APP_FAVICON} />
				</Helmet>
			</HelmetProvider>
			{children}
		</div>
	);
};

export default GuestLayout;
